import { DateTime } from 'luxon';
import { v4 } from 'uuid';
import type { EventGenerateFormValues } from './EventGenerate.types';

export function getEventGenerateScheduleSlotCount(teamCount: number) {
  return Math.max(1, Math.floor(teamCount / 2));
}

export function createEventGenerateInitialGames(
  teamCount: number,
): EventGenerateFormValues['initialGames'] {
  const slotCount = getEventGenerateScheduleSlotCount(teamCount);
  const baseDateTime = DateTime.local().plus({ weeks: 1 }).set({
    hour: 12,
    minute: 0,
    second: 0,
    millisecond: 0,
  });

  return Array.from({ length: slotCount }, (_unused, slotIndex) => ({
    id: v4(),
    datetime: baseDateTime.plus({ hours: slotIndex }).toISO() ?? '',
    location: null,
  }));
}
